import React, { Component } from 'react'
import { connect } from 'react-redux'
import './styles.css'
import { Auth } from 'aws-amplify'
import Alert from 'react-s-alert'

class ChangePassword extends Component {
    email = undefined
    code = undefined
    newPassword = undefined
    state = {
        errorMessage: '',
        disabled: true
    }

    componentDidMount() {
        let urlParams = new URLSearchParams(window.location.search)
        if (urlParams.has('code')) {
            this.code.value = urlParams.get('code')
        }
        if (urlParams.has('email')) {
            this.email.value = urlParams.get('email')
        }
    }

    checkOnChange(event) {
        this.setState({ disabled: true })
        if (this.email && this.email.value !== '' && this.code && this.code.value !== '' && this.newPassword && this.newPassword.value !== '') {
            this.setState({ disabled: false })
        }
    }

    onConfirmPassword() {
        let self = this
        this.setState({ errorMessage: '' })

        Auth.forgotPasswordSubmit(this.email.value, this.code.value, this.newPassword.value)
            .then(result => {
                console.log('on confirm change password success result: ', result)
                alert('Password changed successfully! please login with the new credentials!')
                //Alert.success('Password changed successfully! please login with the new credentials!')
                window.location.href = '/' // goto login
            })
            .catch(err => {
                console.error('on confirm change password error', err)
                self.setState({ errorMessage: err })
            })
    }

    render() {
        return (
            <div className="login-register-wrapper">
                <div className="login-register">
                    <div className="login-register picture" />
                    <div className="login-box login-sidebar">
                        <img className="ar-logo" src="/img/header-logo.png" alt="Audience Rate" />
                        <form
                            onSubmit={e => {
                                e.preventDefault()
                                e.stopPropagation()
                                //this.onConfirmPassword()
                            }}>
                            <div>
                                <div className="login-input-wrapper email-wrapper">
                                    <input
                                        name="email"
                                        type="text"
                                        disabled={this.props.loading}
                                        placeholder="Email"
                                        ref={node => (this.email = node)}
                                        onChange={e => this.checkOnChange(e)}
                                    />
                                </div>
                                <div className="login-input-wrapper">
                                    <input
                                        name="aadasdad"
                                        type="text"
                                        disabled={this.props.loading}
                                        autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="none"
                                        spellCheck="false"
                                        placeholder="Code"
                                        ref={node => (this.code = node)}
                                        onChange={e => this.checkOnChange(e)}
                                    />
                                </div>
                                <div className="login-input-wrapper">
                                    <input
                                        type="password"
                                        name="newPassword"
                                        disabled={this.props.loading}
                                        autoComplete="false"
                                        autoCorrect="false"
                                        autoCapitalize="none"
                                        spellCheck="false"
                                        readOnly
                                        onFocus={event => event.target.removeAttribute('readonly')}
                                        placeholder="New Password"
                                        ref={node => (this.newPassword = node)}
                                        onChange={e => this.checkOnChange(e)}
                                    />
                                    <span className="info">
                                        Password must have a minimum of 8 characters with almost one uppercase character, one lowercase character, one number
                                        and one symbol.
                                    </span>
                                </div>
                                <div className="login-input-wrapper">
                                    <button type="submit" disabled={this.state.disabled} id="forgot-password" onClick={() => this.onConfirmPassword()}>
                                        Reset password
                                    </button>
                                </div>
                            </div>
                        </form>
                        {this.props.loading && (
                            <div className="login-loading-wrapper">
                                <i className="fa fa-spin fa-spinner" />
                            </div>
                        )}

                        {!this.props.loading && this.state.errorMessage && this.state.errorMessage.message && (
                            <div className="login-error-wrapper">{this.state.errorMessage.message}</div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    state => ({}),
    {}
)(ChangePassword)
